import React from 'react';
import { Resource } from 'react-admin';
import { Route } from 'react-router-dom';

import { CompanySettingsPage } from '../../pages/settings/';
// import {customersEmployeesResource} from "../../resources/customer-employees";
import { customerUsers } from '../../resources/customer-users';
import { customerDriversResource } from '../../resources/drivers/';
import Messages from '../../resources/messages/List/List';
import {OrderEditByTransporter, OrderShowTabsWrapper, commonOrdersResourceData, ordersResource} from '../../resources/orders/';
import { transportTrailersResource } from '../../resources/trailers';
import { transportTrucksResource } from '../../resources/trucks';

export const transporterAdminResources = [
	<Resource name="orders" list={ordersResource.list} edit={OrderEditByTransporter} show={OrderShowTabsWrapper} />,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource {...transportTrucksResource} name="trucks" />,
	<Resource {...transportTrailersResource} name="trailers" />,
	// <Resource {...customersEmployeesResource} name="customer-employees" />,
	<Resource {...customerUsers} name="customer-users" options={{ label: 'Employees' }} />,
	<Resource name="mappers" intent="registration"/>,
	<Resource name="ports" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="terminal"/>,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist" intent="registration" />,
	<Resource name="drivers" {...customerDriversResource} />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="external-terminal" intent="registration" />,
	
	<Resource name="company-notifications" intent="registration" />,
];

export const transporterAdminRoutes = [
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/notifications" component={CompanySettingsPage} />,
];
